export default "__VITE_ASSET__C9QNq6b2__"